import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GenericPage from '../../components/GenericPage';
import {
    fetchReportdailytransactions,
    downloadReportDailyTransaction,
    setPagination,
    setSort,
    searchReportdailytransactions,
    setDefaultFilter,
    changeCondition,
    addNewCondition,
    updateOptionRule,
    updateOptionValue,
    removeCondition,
    saveFilterCondition,
    setSelected,
    resetFiltersAndPagination,

    changeClassicFilter
} from '../../store/modules/reportdailytransactions/reportdailytransactionsActions';
import ReportDailyTransactionForm from '../../components/pageModule/Reportdailytransactions/ReportDailyTransactionForm';

const Reportdailytransactions = ({
    excludedActions = [],
    onSelectedRowsChange = () => { },
    onClickedRow = () => { },
    externalCondition = {},
    selectedIds = []
}) => {

    const reportdailytransactionsState = useSelector(state => state.reportdailytransactions);
    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            dispatch(resetFiltersAndPagination());
        };
    }, []);

    const handleDownload = async (type) => {
        try {
            const response = await dispatch(downloadReportDailyTransaction(type));
            window.open(response.url, '_blank')
            return response;
        } catch (error) {
            toast.error(error.message || 'Error downloading report', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    };

    const columns = [
        {
            name: 'Date',
            selector: row => row.payment_date,
            sortable: true,
            sortField: 'payment_date',
        },
        {
            name: 'Job Order',
            selector: row => row.order_number,
            sortable: true,
            sortField: 'order_number',
            minWidth: '200px',
        },
        {
            name: 'Receipt #',
            selector: row => row.receipt_number ?? '-',
            minWidth: '200px',
        },
        {
            name: 'Amount Received',
            selector: row => row.amount_applied != null ? parseFloat(row.amount_applied).toFixed(3) : '-',
            sortable: true,
            sortField: 'amount_applied',
            minWidth: '150px',
        },
        {
            name: 'Type',
            selector: row => row.payment_type_label,
            minWidth: '130px',
        },
        {
            name: 'Method',
            selector: row => row.payment_method_label,
            sortable: true,
            sortField: 'payment_method',
            minWidth: '150px',
        },
    ];

    const actions = {
        fetch: (queryFilter, activeFilter, shouldUseFilter, externalCondition) => dispatch(fetchReportdailytransactions(queryFilter, activeFilter, shouldUseFilter, externalCondition)),
        download: handleDownload,
        setPagination: (pagination) => dispatch(setPagination(pagination)),
        setSort: (sort) => dispatch(setSort(sort)),
        setDefaultFilter: (filter) => dispatch(setDefaultFilter(filter)),
        changeCondition: (index, condition) => dispatch(changeCondition(index, condition)),
        addNewCondition: (rule) => dispatch(addNewCondition(rule)),
        updateOptionRule: (index, rule) => dispatch(updateOptionRule(index, rule)),
        updateOptionValue: (index, value) => dispatch(updateOptionValue(index, value)),
        removeCondition: (index) => dispatch(removeCondition(index)),
        saveFilterCondition: (filter) => dispatch(saveFilterCondition(filter)),
        setSelected: (selectedRows) => dispatch(setSelected(selectedRows)),

        onClassicFilterChange: (name, value) => dispatch(changeClassicFilter(name, value)),
    };

    const defaultAvailableActions = ['export_pdf', 'export_excel'];
    const availableActions = defaultAvailableActions.filter(action => !excludedActions.includes(action));

    return (
        <>
            <GenericPage
                title="Daily Transactions"
                moduleName="ReportDailyTransactions"
                moduleKey="reportdailytransactions"
                state={reportdailytransactionsState}
                actions={actions}
                FormComponent={ReportDailyTransactionForm}
                columns={columns}
                availableActions={availableActions}
                actionsColumnWidth="150px"
                selectableRows={false}
                onSelectedRowsChange={onSelectedRowsChange}
                onClickedRow={onClickedRow}
                selectedIds={selectedIds}
                externalCondition={externalCondition}
            />
        </>
    );
};

export default Reportdailytransactions;